<template>
  <div id="taskManagement">
    <!-- <iframe :src="url" width="100%" height="100%" scrolling="auto"></iframe> xxl-job-admin/jobinfo/index1-->
    <!-- 搜索栏 -->
    <div class="search-box">
      <div>
        <span class="title">执行器</span>
        <Select v-model="jobGroup" style="width: 208px; margin-right: 10px;" @on-change="handleTask">
          <Option v-for="item in selectList" :value="item.id" :key="item.id">{{ item.title }}</Option>
        </Select>
        <Select v-model="triggerStatus" style="width: 208px; margin-right: 10px;" @on-change="handleChange">
          <Option v-for="item in allSelect" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <Input v-model="jobDesc" prefix="ios-search-outline" placeholder="请输入任务描述"
          style="width: 208px; margin-right: 10px;" @on-enter="handleSearchClick" />
        <Input v-model="executorHandler" prefix="ios-search-outline" placeholder="请输入JobHandler"
          style="width: 208px; margin-right: 10px;" @on-enter="handleSearchClick" />
        <Input v-model="author" prefix="ios-search-outline" placeholder="请输入负责人"
          style="width: 208px; margin-right: 10px;" @on-enter="handleSearchClick" />
        <Button class="ys-confirm" @click="handleSearchClick">搜索</Button>
        <Button class="ys-confirm" @click="handleClear">清除</Button>
      </div>
      <div>
        <Button type="primary" icon="ios-add" @click="handleAddClick">新增</Button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table :columns="Columns" :tableData="tableData" :loading="tableLoading" :tableHeight="tableHeight"
      @on-btn-click="onBtnClick">
    </el-table>
    <!-- 分页 -->
    <div class="paging-box">
      <Page :current="page" :page-size="12" :total="totalCount" @on-change="handlePagingClick" />
    </div>
    <!-- 新增以及编辑 -->
    <model-task v-if="modelStatus" :modelStatus="modelStatus" :title="title" :id="id" @handle-model="handleModel" />
    <!-- 执行一次 -->
    <handle-cancle :cancleStatus="cancleStatus" @handle-cancle-model="handleCancleModel"></handle-cancle>
    <!-- 下次执行时间 -->
    <next-timer :nextStatus="nextStatus" :cronList="cronList" @handle-next-model="handleNextModel"></next-timer>
    <!-- 注册节点 -->
    <register-model :registerStatus="registerStatus" :regiseterObj="regiseterObj"
      @handle-register-model="handleRegisterModel"></register-model>
    <div>
      <Alter ref="alterModal" :configData="configData" @change_ok="confirmDel"></Alter>
    </div>
  </div>
</template>
<script>
  import {
    mapActions
  } from "vuex";
  import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
  import ElTable from '_g/commonComponent/table/elTable.vue';
  import ModelTask from './Model';
  import HandleCancle from './handleCancle';
  import NextTimer from './nextTimer';
  import RegisterModel from './registerModel';
  export default {
    components: {
      'el-table': ElTable,
      'model-task': ModelTask,
      'handle-cancle': HandleCancle,
      'next-timer': NextTimer,
      'register-model': RegisterModel
    },
    data() {
      return {
        tableData: [],
        // 数据
        selectList: null,
        Columns: [], // 表头
        totalCount: 0, // 总条数
        tableHeight: 0,
        searchValue: '', // 搜索框的值
        modelStatus: false, // 控制弹框
        cancleStatus: false, // 执行一次弹框
        nextStatus: false,
        registerStatus: false,
        title: '新增',
        page: 1, // 当前页
        jobDesc: '', // 任务描述
        executorHandler: '',
        author: '', // 负责人
        jobGroup: '',
        triggerStatus: '',
        allSelect: [{
            value: -1,
            label: '全部'
          },
          {
            value: 0,
            label: '停止'
          },
          {
            value: 1,
            label: '运行'
          }
        ],
        configData: {}, // 弹框配置信息
        id: '',
        cronList: [],
        regiseterObj: {},
        tableLoading: true, // 表格loading
      }
    },
    methods: {
      ...mapActions([
        'sa_SpringJobInfoView_index', // 下拉列表
        'sa_SpringJobInfoView_pageList', // 分页
        'sa_SpringJobInfoView_remove', // 删除
        'sa_SpringJobInfoView_start', // 启动
        'sa_SpringJobInfoView_stop', // 停止
        'sa_SpringJobInfoView_trigger', // 执行一次
        'sa_SpringJobInfoView_nextTriggerTime', // 下次执行时间
        'sa_SpringJobGroupView_loadById', // 注册节点
      ]),
      // 获取元素的高度
      getElementHeight() {
        let ERD = elementResizeDetectorMaker();
        let _this = this;
        ERD.listenTo(document.getElementById("taskManagement"), (element) => {
          _this.tableHeight = (element.scrollHeight - 66 - 90);
        });
      },
      // 操作按钮
      onBtnClick(rowItem, options) {
        console.log(rowItem, '----', options)
        this.id = options.id;
        switch (rowItem) {
          case '删除':
            this.DeleteComponent();
            break;
          case '启动':
            this.sa_SpringJobInfoView_starts();
            break;
          case '停止':
            this.sa_SpringJobInfoView_stops();
            break;
          case '执行一次':
            this.cancleStatus = true;
            break;
          case '下次执行时间':
            this.sa_SpringJobInfoView_nextTriggerTimes(options.jobCron);
            break;
          case '编辑':
            console.log('编辑');
            this.modelStatus = true;
            break;
          case '注册节点':
            console.log('注册节点')
            this.sa_SpringJobGroupView_loadByIds(options.jobGroup);
            break;
          default:
            break;
        }
      },
      // 删除
      DeleteComponent() {
        this.configData = {
          type: "warning",
          title: "警告",
          content: "是否删除当前信息"
        };
        this.$refs.alterModal.OpenModal();
      },
      confirmDel() {
        this.sa_SpringJobInfoView_removes();
      },
      // 新建功能
      handleAddClick() {
        this.id = "";
        this.modelStatus = true;
      },
      // 清除
      handleClear() {
        this.jobDesc = ""; // 任务描述
        this.executorHandler = "";
        this.author = ""; // 负责人
        this.jobGroup = "";
        this.triggerStatus = "";
      },
      // 搜索功能
      handleSearchClick() {
        this.page = 1;
        console.log('111')
        this.sa_SpringJobInfoView_pageLists();
      },
      // 分页功能
      handlePagingClick(res) {
        this.page = res;
        this.sa_SpringJobInfoView_pageLists();
      },
      // 新增执行器弹框回调
      handleModel(res) {
        this.modelStatus = false;
        // 刷新列表
        this.sa_SpringJobInfoView_pageLists();
      },
      // 执行一次的弹框回调
      handleCancleModel(res) {
        console.log(res, '---')
        this.cancleStatus = false;
        res.code === 1 ? this.sa_SpringJobInfoView_triggers(res.executorParam) : '';
      },
      // 下次执行时间弹框回调
      handleNextModel() {
        this.nextStatus = false;
      },
      handleRegisterModel() {
        this.registerStatus = false;
      },
      // 执行器下拉列表
      handleTask(res) {
        this.page = 1;
        console.log(res, '---')
        this.sa_SpringJobInfoView_pageLists();
      },
      // 类别
      handleChange(res) {
        this.page = 1;
        console.log(res, '----')
        this.sa_SpringJobInfoView_pageLists();
      },
      // 获取下拉列表
      async sa_SpringJobInfoView_indexs() {
        try {
          const data = await this.sa_SpringJobInfoView_index();
          console.log(data, '----')
          this.selectList = data.JobGroupList;
        } catch (error) {
          console.log(error);
        }
      },
      // 获取分页列表
      async sa_SpringJobInfoView_pageLists() {
        try {
          this.tableLoading = true;
          const parmas = {
            start: (this.page - 1) * 12,
            length: 12,
            jobGroup: this.jobGroup,
            triggerStatus: this.triggerStatus === "" ? -1 : this.triggerStatus === 0 ? 0 : this.triggerStatus,
            jobDesc: this.jobDesc,
            executorHandler: this.executorHandler,
            author: this.author
          };
          const data = await this.sa_SpringJobInfoView_pageList(parmas);
          this.tableData = data.data;
          this.totalCount = data.recordsTotal;
          this.tableLoading = false;
        } catch (error) {
          console.log(error);
          this.tableLoading = false;
        }
      },
      // 删除
      async sa_SpringJobInfoView_removes() {
        try {
          const data = await this.sa_SpringJobInfoView_remove({
            id: this.id
          });
          console.log(data, '----')
          this.$Message.success('删除成功~~');
          this.sa_SpringJobInfoView_pageLists();
        } catch (error) {
          console.log(error);
        }
      },
      // 停止
      async sa_SpringJobInfoView_stops() {
        try {
          const data = await this.sa_SpringJobInfoView_stop({
            id: this.id
          });
          console.log(data, '----')
          this.$Message.success('停止成功~~');
          this.sa_SpringJobInfoView_pageLists();
        } catch (error) {
          console.log(error);
        }
      },
      // 启动
      async sa_SpringJobInfoView_starts() {
        try {
          const data = await this.sa_SpringJobInfoView_start({
            id: this.id
          });
          console.log(data, '----')
          this.$Message.success('启动成功~~');
          this.sa_SpringJobInfoView_pageLists();
        } catch (error) {
          console.log(error);
        }
      },
      // 执行一次
      async sa_SpringJobInfoView_triggers(options) {
        try {
          const data = await this.sa_SpringJobInfoView_trigger({
            id: this.id,
            executorParam: options
          });
          console.log(data, '----')
          this.$Message.success('执行成功~~');
          this.sa_SpringJobInfoView_pageLists();
        } catch (error) {
          console.log(error);
        }
      },
      // 下次执行时间
      async sa_SpringJobInfoView_nextTriggerTimes(options) {
        try {
          const data = await this.sa_SpringJobInfoView_nextTriggerTime({
            cron: options
          });
          console.log(data, '----ssss')
          this.cronList = data;
          this.nextStatus = true;
        } catch (error) {
          console.log(error);
        }
      },
      // 注册节点 
      async sa_SpringJobGroupView_loadByIds(options) {
        try {
          const data = await this.sa_SpringJobGroupView_loadById({
            jobGroup: options
          });
          console.log(data, '----ssss')
          this.regiseterObj = data;
          this.registerStatus = true;
        } catch (error) {
          console.log(error);
        }
      }
    },
    mounted() {
      let _this = this;
      this.Columns = [{
          title: '任务ID',
          key: 'id',
          width: 150
        },
        {
          title: '任务描述',
          key: 'jobDesc',
          width: 250,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '运行模式',
          width: 200,
          render: (h, params) => {
            let fromIP = params.row.glueType;
            let toIP = params.row.executorParam;
            let result = "--";
            if (fromIP && toIP) {
              result = `${fromIP}:${toIP}`;
            }
            return h("div", result);
          },
        },
        {
          title: 'Cron',
          key: 'jobCron',
          width: 150,
        },
        {
          title: '负责人',
          key: 'author',
          width: 150,
        },
        {
          title: '状态',
          render: (h, params) => {
            let fromIP = params.row.triggerStatus;
            console.log(fromIP, 'fromIP')
            let result = "--";
            result = fromIP === 0 ? '停止' : '运行'
            return h("div", result);
          },
        },
        {
          title: "操作",
          slot: "iconfont",
          width: 500,
          render(h, {
            columns,
            row,
            index
          }) {
            return h('div', [
              h(
                "span", {
                  class: {
                    'ys-text': true,
                  },
                  style: {
                    marginRight: '6px'
                  },
                  on: {
                    click: () => {
                      //修改锁定状态
                      _this.onBtnClick('执行一次', row)
                    }
                  }
                },
                '执行一次'
              ),
              h(
                "span", {
                  class: {
                    'ys-text': true,
                  },
                  style: {
                    marginRight: '6px'
                  },
                  on: {
                    click: () => {
                      //修改锁定状态
                      _this.onBtnClick('查询日志', row)
                    }
                  }
                },
                '查询日志'
              ),
              h(
                "span", {
                  class: {
                    'ys-text': true,
                  },
                  style: {
                    marginRight: '6px'
                  },
                  on: {
                    click: () => {
                      //修改锁定状态
                      _this.onBtnClick('注册节点', row)
                    }
                  }
                },
                '注册节点'
              ),
              h(
                "span", {
                  class: {
                    'ys-text': true,
                  },
                  style: {
                    marginRight: '6px'
                  },
                  on: {
                    click: () => {
                      //修改锁定状态
                      _this.onBtnClick('下次执行时间', row)
                    }
                  }
                },
                '下次执行时间'
              ),
              h(
                "span", {
                  class: {
                    'ys-text': true,
                  },
                  style: {
                    marginRight: '6px'
                  },
                  on: {
                    click: () => {
                      //修改锁定状态
                      _this.onBtnClick(row.triggerStatus === 0 ? '启动' : '停止', row)
                    }
                  }
                },
                row.triggerStatus === 0 ? '启动' : '停止'
              ),
              h(
                "span", {
                  class: {
                    'ys-text': true,
                  },
                  style: {
                    marginRight: '6px'
                  },
                  on: {
                    click: () => {
                      //修改锁定状态
                      _this.onBtnClick('编辑', row)
                    }
                  }
                },
                '编辑'
              ),
              h(
                "span", {
                  class: {
                    'ys-text': true,
                  },
                  style: {
                    marginRight: '6px'
                  },
                  on: {
                    click: () => {
                      //修改锁定状态
                      _this.onBtnClick('删除', row)
                    }
                  }
                },
                '删除'
              )
            ])
          },
        },
      ];
      // 获取元素高度
      this.getElementHeight();
      // 获取下拉列表
      this.sa_SpringJobInfoView_indexs();
      // 获取list
      this.sa_SpringJobInfoView_pageLists();
    }
  }
</script>
<style lang="less" scoped>
  #taskManagement {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;

    .search-box {
      width: 100%;
      height: 66px;
      padding: 22px 0px 12px 0px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;

      .title {
        font-size: 14px;
        color: #fff;
        margin: 0px 10px 0px 10px;
      }
    }

    .paging-box {
      position: fixed;
      bottom: 0px;
      right: 50px;
      z-index: 1;
      height: 60px;
      width: calc(100% - 250);
      text-align: right;
    }
  }
</style>